// eslint-disable-next-line max-classes-per-file
import { Activity, FabricAirflowLinkedService, IAttribute, IModel, IViolation, format } from 'shell-models-lib';
import { Metamodel } from '../base/model';

@Metamodel.model({
    name: 'InvokeFabricAirflowJob',
    referable: true
})
export class AirflowActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly WORKSPACE_ID: IAttribute;
    public static readonly AIRFLOW_ID: IAttribute;
    public static readonly DAG_ID: IAttribute;
    public static readonly WAIT_ON_COMPLETION: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ConnectionLabel,
        reference: true,
        type: FabricAirflowLinkedService.MODEL,
        constraint: {
            validator: AirflowActivity.validateConnection
        }
    })
    public airflowLinkedService?: FabricAirflowLinkedService;

    @Metamodel.attribute({
        association: 'WORKSPACE_ID',
        templatable: true,
        constraint: {
            required: true
        }
    })
    public workspaceId?: string;

    @Metamodel.attribute({
        association: 'AIRFLOW_ID',
        templatable: true,
        constraint: {
            required: true
        }
    })
    public airflowId?: string;

    @Metamodel.attribute({
        association: 'DAG_ID',
        templatable: true,
        accepts: ['String'],
        constraint: {
            required: true
        }
    })
    public dagId?: string;

    @Metamodel.attribute({
        association: 'WAIT_ON_COMPLETION'
    })
    public waitOnCompletion: boolean = true;

    private static validateConnection(
        _activity?: {},
        connection?: FabricAirflowLinkedService
    ): IViolation[] | undefined {
        return connection
            ? undefined
            : [{ message: () => format(stringResources.RequiredTemplate, stringResources.ConnectionLabel) }];
    }
}
